/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Tracking_DescriptionInputs */

const en_case_payment_tracking_description = /** @type {(inputs: Case_Payment_Tracking_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm payments and follow outstanding amounts.`)
};

const pt_br2_case_payment_tracking_description = /** @type {(inputs: Case_Payment_Tracking_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirme pagamentos e acompanhe os valores pendentes.`)
};

/**
* | output |
* | --- |
* | "Confirm payments and follow outstanding amounts." |
*
* @param {Case_Payment_Tracking_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_tracking_description = /** @type {((inputs?: Case_Payment_Tracking_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Tracking_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_tracking_description(inputs)
	return pt_br2_case_payment_tracking_description(inputs)
});